if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', afterDOMLoaded);
} else {
    afterDOMLoaded();
}

function afterDOMLoaded() {
    try { setTimeout(mobileNavigationButtons, 500); } catch (err) { console.error('error in custom.js mobileNavigationButtons, err: ', err); }

    if(window.location.href.includes('swym-wishlist')) {
        try { setTimeout(wishListPage, 3000);  } catch(err) {console.error('error in custom.js wishListPage function, err: ', err); }
    }
    if(window.location.href.includes('swym-share-wishlist')) {
        try { setTimeout(sharedWishlist, 3000);  } catch(err) {console.error('error in custom.js wishListPage function, err: ', err); }
    }
    
    if (document.body.classList.contains('template-product')) {
    try { moveElementBasedOnWidth();} catch (err) {console.error('error in custom.js, moveElementBasedOnWidth function. err:', err);}
    try { stickyATCADA();} catch (err) {console.error('error in custom.js, stickyATCADA function. err:', err);}
    }

    if (document.body.classList.contains('template-cart')) {
        try { setTimeout(cartCheckbox, 1000);} catch (err) {console.error('error in custom.js, cartCheckbox function. err:', err);}
     }
}

function moveElementBasedOnWidth() {
  // Get the element and the target container
  const headerElement = document.querySelector(".product-single__meta .product-block--header")
  const widthCopy = document.querySelector(".width-copy")
  const yotpoEmbed = document.querySelector("div[id*='yotpo_product_reviews_star_rating']");

  headerElement.appendChild(widthCopy);
  headerElement.appendChild(yotpoEmbed);
  
  const targetContainer = document.querySelector(".page-content--product .page-width .grid");
  const originalContainer = document.querySelector(".grid__item medium-up--two-fifths .product-single__meta")

  
 // Function to move the element based on the width
  function checkWidthAndMove() {
    if (window.innerWidth < 768) {
      // Move the element to the target container as the first child
      targetContainer.insertBefore(headerElement, targetContainer.firstChild);
    } else {
      // Otherwise, append the element back to its original parent container
      originalContainer.insertBefore(headerElement, originalContainer.firstChild); // Replace with the original container if needed
    }
  }

  // Run the check on page load
  checkWidthAndMove();

   // Listen to window resize events
  window.addEventListener('resize', checkWidthAndMove);
}

// Add Aria-Labels to Sticky ATC Icons
function stickyATCADA() {
    const variantDropdownSVGs = document.querySelectorAll('div[data-essential-cart-element="variant-select"] div[data-essential-cart-element="icon"] svg');
    if(variantDropdownSVGs) {
        variantDropdownSVGs.forEach(variantDropdownSVG => {
            variantDropdownSVG.setAttribute("aria-label", "Variant Selection Dropdown")
        })
        
    }

    const quantityLessButtons = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] button:first-of-type');
    const quantityLessSVGs = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] div[data-essential-cart-element="icon"] svg:has(path[d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"])');
    if (quantityLessButtons && quantityLessSVGs) {
        quantityLessButtons.forEach(quantityLessButton => {
            quantityLessButton.setAttribute("aria-label", "Reduce item quantity by one");
        })
        quantityLessSVGs.forEach(quantityLessSVG => {
            quantityLessSVG.setAttribute("aria-label", "Reduce item quantity by one");
        })
       
    }

    const quantityMoreButtons = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] button:last-of-type');
    const quantityMoreSVGs = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] div[data-essential-cart-element="icon"] svg:has(path[d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"])');
    if (quantityMoreButtons && quantityMoreSVGs) {
        quantityMoreButtons.forEach(quantityMoreButton => {
            quantityMoreButton.setAttribute("aria-label", "Increase item quantity by one"); 
        })
        quantityMoreSVGs.forEach(quantityMoreSVG => {
            quantityMoreSVG.setAttribute("aria-label", "Increase item quantity by one");
        })
        
        
    }
}

/**
 * Change Tab Index Attribute of Mobile Navigation Dropdowns
 */
function mobileNavigationButtons() {
    const dropdownButtons = document.querySelectorAll('div.mobile-nav__toggle button.collapsible-trigger');
    if (dropdownButtons) {
        dropdownButtons.forEach(dropdownButton => {
        dropdownButton.setAttribute('tabindex', '0');
        })
    }
}

// WishList Page Customizations
function wishListPage() {
    const loginBlock = document.querySelector('div.swym-storefront-layout-login-user-container');
    if (loginBlock) {
        const parentLoginBlock = loginBlock.parentNode;
        const wishListWrapper = document.querySelector('.swym-storefront-layout-tab-container');
        const wishListBody = document.querySelector('div.swym-storefront-layout-body');

        wishListWrapper.insertBefore(parentLoginBlock, wishListBody);

    }
   

    // remove '+' from arrow 
    const ATCButtons = document.querySelectorAll('button.swym-storefront-layout-grid-item-add-to-cart-button:not(button[disabled])');
    if(ATCButtons) {
    ATCButtons.forEach(ATCButton => {
        ATCButton.innerHTML = 'Add to Cart';
        })
    }

    const shareSVGButton = document.querySelector('button.swym-single-share-wishlist-btn');
    if (shareSVGButton) {
        const shareCopy = document.createElement('span');
        shareCopy.innerHTML = 'Share Wishlist';
        shareCopy.setAttribute('class', 'share-copy');
        shareCopy.style.textDecoration = 'underline';
        shareCopy.style.fontWeight = '600';

        const shareSVG = document.querySelector('button.swym-single-share-wishlist-btn svg');
        shareSVG.style.display = "none";
        shareSVGButton.insertBefore(shareCopy, shareSVG);
    }

    const loginHeading = document.querySelector('.swym-storefront-layout-login-heading');
    const loginCopy = document.querySelector('.swym-storefront-layout-login-description');
    if (loginHeading && loginCopy) {
        loginHeading.innerHTML = 'Don\'t lose your list.';
        loginCopy.innerHTML = 'Login to save your favorites and access them whenever.'
    }

} 

// Shared Wishlist Page Customizations
function sharedWishlist() {
    const wishlistTitle = document.querySelector('.swym-wishlist-main-title.swym-heading');
    if (wishlistTitle) {
        wishlistTitle.remove();
        const newTitle = document.createElement('h1');
        newTitle.setAttribute('class', 'swym-wishlist-main-title');
        newTitle.innerHTML = "Shared Wishlist";
        const parentWrapper = document.querySelector('.swym-wishlist-detail-header');
        const siblingElement = document.querySelector('.swym-wishlist-name-container');
        parentWrapper.insertBefore(newTitle, siblingElement);
    }
}

/** 
 * Add Aria-Label to T&C Checkbox in Cart
 */
function cartCheckbox() {
    const termsCheckbox = document.querySelector('span.rale-box svg');
    if(termsCheckbox){
        termsCheckbox.setAttribute('aria-label', 'Accept terms of purchase and website use');
    }
}